module.exports = __webpack_public_path__ + "static/downloable/autorizacion-para-el-uso-y-tratamiento-de-datos-personales.b77428b.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/downloable/autorizacion-para-el-uso-y-tratamiento-de-datos-personales.pdf
// module id = 7uXd
// module chunks = 1